// For the authentication cookie
export const ALPHA_AUTH_KEY = 'unvoid-alpha-auth';
export const ALPHA_AUTH_VALUE = '8J+QrPCfkKzwn5Cs8J+QrPCfkKw=';

// For the authentication verification
export const ALPHA_LOGIN_NAME = 'admin';
export const ALPHA_LOGIN_PASS = 'changeme';
